import React, { forwardRef } from "react";

import { StyledDateWrapper } from "./dateField.style";
import GenericInputField, {
  TYPES,
  Label,
} from "../../../genericInputFields/genericInputField";

const DateField = forwardRef(
  (
    {
      name,
      formMethods,
      error,
      required,
      title,
      placeholder,
      minValue,
      maxValue,
    },
    ref,
  ) => {
    const { register } = formMethods;

    return (
      <StyledDateWrapper ref={ref}>
        <Label required={required}>{title}</Label>
        <GenericInputField
          type={TYPES.DATE}
          register={register}
          name={name}
          required={required}
          placeholder={placeholder}
          minValue={minValue}
          maxValue={maxValue}
          error={error}
        />
      </StyledDateWrapper>
    );
  },
);
DateField.displayName = "DateField";

export default DateField;
